import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["backgroundColor", "children", "withBorder"];
import React from 'react';
import { PageFixer } from '@beef/smart-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var WidthFixer = function WidthFixer(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'main' : _ref$backgroundColor,
    children = _ref.children,
    withBorder = _ref.withBorder,
    pageFixerProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('component', withBorder && 'with-border', "background-".concat(backgroundColor)),
    style: {
      backgroundColor: pageFixerProps.backgroundCustomColor
    }
  }, /*#__PURE__*/React.createElement(PageFixer, _extends({
    backgroundColor: backgroundColor,
    size: "m"
  }, pageFixerProps), children));
};